<template>
  <div>
    <v-sheet height="100%" color="black" tile
      ><v-container>
        <h1 class="pt-5 pb-5">What Do You Want To Do?</h1>
        <v-row align="center" justify="center">
          <v-col cols="12" md="4" lg="4" sm="12">
            <v-card
              class="mx-auto pl-5 pr-5 pb-5 pt-5"
              max-width="250"
              color="white"
            >
              <v-img
                src="https://img.freepik.com/free-photo/businessman-s-torso-suit_144627-3822.jpg?w=740&t=st=1662458976~exp=1662459576~hmac=7ab7984f7a78f61a7c4250a1afd58ff60b720c76936127abb76fad26867ea25b"
                height="150px"
                class="inner-img"
              ></v-img>

              <h2 class="pt-3">I Want to <br />Migrate</h2>
              <p>Work & settle in the World's Best Countries!</p>
              <div class="text-center">
                <v-btn class="mx-2" fab dark small color="black">
                  <v-icon dark> mdi-arrow-right-bold-circle </v-icon>
                </v-btn>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" lg="4" sm="12">
            <v-card
              class="mx-auto pl-5 pr-5 pb-5 pt-5"
              max-width="250"
              color="white"
            >
              <v-img
                src="https://img.freepik.com/free-photo/certificate-with-ribbon-bow-books_23-2148769681.jpg?w=996&t=st=1662459343~exp=1662459943~hmac=140771d6dcbe78e893b75199cb3a56fb32dafac35adb6fc03a70b224eadea830"
                height="150px"
                class="inner-img"
              ></v-img>

              <h2 class="pt-3">I Want to <br />Study</h2>
              <p>Study in Globality-recognized Universities!</p>
              <div class="text-center">
                <v-btn class="mx-2" fab dark small color="black">
                  <v-icon dark> mdi-arrow-right-bold-circle </v-icon>
                </v-btn>
              </div>
            </v-card></v-col
          >
          <v-col cols="12" md="4" lg="4" sm="12">
            <v-card
              class="mx-auto pl-5 pr-5 pb-5 pt-5"
              max-width="250"
              color="white"
            >
              <v-img
                src="https://img.freepik.com/free-photo/two-male-hiker-sitting-top-rock-mountain-looking-scenic-view_23-2148182804.jpg?w=740&t=st=1662459400~exp=1662460000~hmac=4e1fb1c626abea1290ad0b86773ffe1d82392493ff465ad1fd2fffa074ae8370"
                height="150px"
                class="inner-img"
              ></v-img>

              <h2 class="pt-3">I Want to <br />Visit</h2>
              <p>The World's your Oyster! Travel far & beyond..</p>
              <div class="text-center">
                <v-btn class="mx-2" fab dark small color="black">
                  <v-icon dark> mdi-arrow-right-bold-circle </v-icon>
                </v-btn>
              </div>
            </v-card></v-col
          >
        </v-row>
      </v-container>
    </v-sheet>

    <v-sheet height="100%" color="black" tile
      ><v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" md="4" lg="4" sm="12">
            <v-card
              class="mx-auto pl-5 pr-5 pb-5 pt-5"
              max-width="250"
              color="white"
            >
              <v-img
                src="https://img.freepik.com/free-photo/business-team-working-office-worker-concept_53876-23476.jpg?w=996&t=st=1662802051~exp=1662802651~hmac=ff30a73f589136e02f46b7826d47b8a3ee2c73499f0a368d98bbfe64c37f4192"
                height="150px"
                class="inner-img"
              ></v-img>

              <h2 class="pt-3">I Want to <br />Work</h2>
              <p>Work & settle in the World's Best Countries!</p>
              <div class="text-center">
                <v-btn class="mx-2" fab dark small color="black">
                  <v-icon dark> mdi-arrow-right-bold-circle </v-icon>
                </v-btn>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" lg="4" sm="12">
            <v-card
              class="mx-auto pl-5 pr-5 pb-5 pt-5"
              max-width="250"
              color="white"
            >
              <v-img
                src="https://img.freepik.com/free-photo/visa-application-travel-form-concept_53876-122710.jpg?w=740&t=st=1662802084~exp=1662802684~hmac=d17899dbfa37fba2e8ff9f230e6ff5fdc6377e5883501a6846fee134dc4e222d"
                height="150px"
                class="inner-img"
              ></v-img>

              <h2 class="pt-3">I Want to <br />Dependent Visa</h2>
              <p>Study in Globality-recognized Universities!</p>
              <div class="text-center">
                <v-btn class="mx-2" fab dark small color="black">
                  <v-icon dark> mdi-arrow-right-bold-circle </v-icon>
                </v-btn>
              </div>
            </v-card></v-col
          >
          <v-col cols="12" md="4" lg="4" sm="12">
            <v-card
              class="mx-auto pl-5 pr-5 pb-5 pt-5"
              max-width="250"
              color="white"
            >
              <v-img
                src="https://img.freepik.com/free-photo/businesswoman-standing-thinking-near-big-question-mark-isolated-white-background_126523-3114.jpg?w=740&t=st=1662802128~exp=1662802728~hmac=35477c127caadb05cf5a63f9be1b26b1bb7c956a66e191ffd6a108ffa5801db8b    bb"
                height="150px"
                class="inner-img"
              ></v-img>

              <h2 class="pt-3">I am not <br />Sure</h2>
              <p>The World's your Oyster! Travel far & beyond..</p>
              <div class="text-center">
                <v-btn class="mx-2" fab dark small color="black">
                  <v-icon dark> mdi-arrow-right-bold-circle </v-icon>
                </v-btn>
              </div>
            </v-card></v-col
          >
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      colors: ["secondary", "secondary"],
      cycle: false,
    };
  },
};
</script>
<style scoped>
h1 {
  text-align: center;
}
h2 {
  color: black;
  text-align: center;
}
p {
  color: black;
  text-align: center;
  font-size: 12px;
  padding-top: 10px;
}

.inner-img {
  transition: 0.3s;
}

.inner-img:hover {
  transform: scale(1.1);
}

/* Other styling elements, that are not necessary for the example */
</style>